// Profile of Nikolai Genov, Swedish. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Hälso- och sjukvård, life science, finans',
  summary: 'Disputerad bioinformatiker och praktiskt verksam teknisk ledare som förenar AI-stödd mjukvaruutveckling med analys i reglerade miljöer inom hälso- och sjukvård, life science och finans. Expertis inom LLM-/RAG-system, MCP-integration, kliniska data, bankprognoser på upp till fem år och automatiserad Excel-rapportering. Kombinerar R-/Python-utveckling med teamkoordinering, kvalitetssäkring och workshoppar på ledningsnivå; AI Act-certifierad och GCP-utbildad.',
  imageAlt: 'Porträtt av Nikolai Genov',
  personal: {
    position: 'Medgrundare och verkställande direktör för pAIoneer Labs GmbH, verkställande direktör för Leap Dynamics GmbH',
    location: 'Berlin, Tyskland',
    languages: 'Tyska och engelska (flytande), bulgariska (flytande)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'AI Act-certifiering, GCP-utbildning (2025)',
    publications: 'Referentgranskade arbeten i Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology och PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Forskarutbildning: bioinformatik / teoretisk biologi',
      institution: '',
      degree: 'Examen: doktorsexamen (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Studier: bioinformatik',
      institution: 'Freie Universität Berlin',
      degree: 'Examen: M.Sc. i bioinformatik'
    },
    {
      period: '2012',
      field: 'Studier: bioinformatik',
      institution: 'Freie Universität Berlin',
      degree: 'Examen: B.Sc. i bioinformatik'
    }
  ],
  skills: [
    {
      title: 'Kärnkompetenser',
      description: 'AI-stödd utveckling, R/Python, LLM/RAG & MCP, kliniska data & bioinformatik, prognoser & stresstester, Excel-rapportering, Shiny, tekniskt ledarskap'
    },
    {
      title: 'Programmering & analys',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Applikationer & rapportering',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; automatiserad Excel-/Word-/PDF-rapportering'
    },
    {
      title: 'AI & integration',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; AI-stödd utveckling med mänsklig granskning'
    },
    {
      title: 'Engineering',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformatik',
      description: 'RNA-seq, microarray, alternativ splitsning/isoformer, gene set enrichment-analys, pathway-/nätverksanalys, genomassemblering, överlevnadsanalys; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Kliniska data',
      description: 'EDC, CRF, edit checks, DMP, datavalideringsplaner, UAT, SAE-avstämning; CDISC SDTM/ADaM, RAW-/SDTM-/ADaM-pipelines, QC'
    }
  ],
  positions: [
    {
      period: '2022 - april 2024',
      title: 'Rapporteringsautomatisering, T-Systems / Europeiska centralbanken (ECB)',
      description: [
        'Utveckling av ett R-bibliotek för statistisk rapportering av finansiella tidsserier; migrering av FAME-logik till R/Python med Reticulate och automatiserade Word-/PDF-utdata.',
        'Utveckling av pipelines för automatiserad generering av Excel-rapporter; integration av analyserna med Camunda samt stöd för GitLab CI/CD, enhetstester, linting, SonarQube och dokumentation.',
        'Ställföreträdare för teamledaren samt medverkan i sprintplanering, teknisk koordinering, kvalitetssäkring och leverans i dialog med intressenter.'
      ]
    },
    {
      period: 'juni 2025 - december 2025',
      title: 'Data Science & Risk Analytics Consultant, banksektorn',
      description: [
        'Utveckling av prognosmodeller med planeringshorisonter på upp till fem år samt implementering av stresstester.',
        'Omskrivning och refaktorering av äldre R-kod, optimering av fyra affärsprocesser samt AI-stödd utveckling med mänsklig granskning för implementering och dokumentation.',
        'Uppbyggnad av R-/Shiny-analysflöden och pipelines för automatiserad generering av Excel-rapporter; omsättning av verksamhetskrav i analytiska implementeringar.'
      ]
    },
    {
      period: 'juni 2025 - juni 2026',
      title: 'Clinical Data Manager, läkemedelsindustri / kliniska studier',
      description: [
        'Ansvar för EDC-uppsättning, CRF-design, edit checks, användarroller, specifikationer för dataöverföring och UAT; koordinering med CRO:er, laboratorier och studieteam.',
        'Framtagning och granskning av DMP:er, valideringsplaner, planer för SAE-avstämning och UAT-dokumentation; utveckling av R-baserade valideringsflöden och Shiny-applikationer i en GCP-relevant miljö.'
      ]
    },
    {
      period: 'juli 2026',
      title: 'Klinisk datapipeline, Dr. Falk Pharma',
      description: [
        'Uppbyggnad av en RAW-/SDTM-/ADaM-pipeline i R med OpenCode och AI-stödd utveckling, med validering, QC, spårbarhet och automatiserade pipelines för Excel-rapporter.'
      ]
    },
    {
      period: '2026',
      title: 'AI-stödd audit trail-rapportering, Miltenyi Biotec',
      description: [
        'Implementering av audit trail-rapporter och automatiserade pipelines för Excel-rapporter med OpenCode och AI-stödd utveckling, inklusive rapportlogik, felsökning, dokumentation och mänsklig granskning.'
      ]
    },
    {
      period: 'Sedan 2019',
      title: 'Verkställande direktör & medgrundare / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Ledning av rådgivning och teknisk leverans inom hälso- och sjukvård, life science, finans och AI, där eget praktiskt genomförande kombineras med teamkoordinering och kommunikation med intressenter.',
        'Utformning av LLM-/RAG-infrastruktur och MCP-baserad verktygsintegration. Etablering av OpenCode-stödda R-/Python-arbetsflöden för kodgenerering, refaktorering, testning och dokumentation med mänsklig granskning.'
      ]
    },
    {
      period: 'Sedan 2022',
      title: 'Cancerregister & biobank, Medical University Pleven',
      description: [
        'Analys av data från det nationella cancerregistret och uppbyggnad av Shiny-dashboards för intressenter inom klinik och forskning; stöd för integration, dokumentation och biobanksarbetsflöden för fem cancertyper.'
      ]
    },
    {
      period: 'Sedan 2025',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Uppbyggnad av en produktionsklar R Shiny-applikation; migrering av CSV-data till SQLite samt administratörsautentisering, institutionshantering, besöksanalys, betalda poster och förfrågningsformulär med SMTP-aviseringar.',
        'Förbättring av responsiv UI/UX, SEO, strukturerade data och stöd för sitemap/robots; indatavalidering, escaping av utdata, begränsning av inloggningsförsök och enbart verifierade offentliga poster. Granskning av över 400 institutioner med hjälp av ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT och AI-on-Demand, med dokumentation av ursprung samt av driftsättning och säkerhet.'
      ]
    },
    {
      period: 'Sedan 2024',
      title: 'LLM-baserad analys av finansnyheter, Leap Dynamics (internt projekt)',
      description: [
        'Uppbyggnad av återkommande arbetsflöden för sentimentanalys med LLM:er, API-data, automatiserade PDF-rapporter, ett Streamlit-gränssnitt, n8n-orkestrering och Flowise-stödd testning av arbetsflöden.'
      ]
    },
    {
      period: '2025',
      title: 'Workshoppar på ledningsnivå, BVMW',
      description: [
        'Genomförande av workshoppar för deltagare på vd-nivå inom BVMW-nätverket.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Vetenskaplig medarbetare, Humboldt-Universität / Charité, Berlin',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO & medgrundare, Promethano GmbH',
      description: [
        'Programvara och tidsserietillämpningar för life science.'
      ]
    }
  ]
};
